const nonEmptyText = (value) => {
  if (value === undefined || value === null) return null;
  const text = String(value).trim();
  return text || null;
};

const validDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

const formatDate = (date, locale) =>
  new Intl.DateTimeFormat(locale || 'fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);

const formatTime = (date, locale) =>
  new Intl.DateTimeFormat(locale || 'fr-FR', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(date);

export const buildAppointmentNotificationSummary = (
  data,
  locale,
  audience = 'professional',
) => {
  const snapshot = data || {};
  const contextName =
    audience === 'client'
      ? nonEmptyText(snapshot.salon_name)
      : nonEmptyText(snapshot.client_name);
  const contextLine = [contextName, nonEmptyText(snapshot.service_name)]
    .filter(Boolean)
    .join(' · ');

  const startTime = validDate(snapshot.start_time);
  const endTime = validDate(snapshot.end_time);
  const scheduleParts = [];

  if (startTime) {
    scheduleParts.push(formatDate(startTime, locale));
    const timeRange = endTime
      ? `${formatTime(startTime, locale)}–${formatTime(endTime, locale)}`
      : formatTime(startTime, locale);
    scheduleParts.push(timeRange);
  }

  const teamMemberName = nonEmptyText(snapshot.team_member_name);
  if (teamMemberName) {
    scheduleParts.push(teamMemberName);
  }

  const scheduleLine = scheduleParts.join(' · ');
  if (!contextLine && !scheduleLine) {
    return null;
  }

  return { contextLine, scheduleLine };
};
